module.exports = __webpack_public_path__ + "img/review.7663f4de.svg";